RivalIQ.apps.Admin.apps.Account.module('controllers', function (controllers, App, Backbone, Marionette, $, _) {

    'use strict';

    const Controller = controllers.Controller = Marionette.Controller.extend({

        start: function (options) {

            const me = this;
            _.extend(me, options);

            if (options.unknown) {
                me.showUnknownAccountView();
            } else {
                me.showAccountDetailsView();
            }
        },

        showUnknownAccountView: function () {
            App.accountDetails.show(new App.views.UnknownAccount());
        },

        showAccountDetailsView: function () {
            const me = this;
            App.accountDetails.show(new App.views.Account({
                model: new RivalIQ.apps.Admin.models.User(me.accountDetails.user),
                intercomAppId: me.intercomAppId,
                accountDetails: me.accountDetails
            }));
        }

    });

    controllers.addInitializer(function (options) {
        const controller = new Controller();
        controller.start(options);
    });
});
